export const CUSTOMER_STATUS_ACTIVE = 'active'
export const CUSTOMER_STATUS_ARCHIVE = 'archive'
